export default __webpack_public_path__ + "static/media/crushphone.e059f8fc.png";